module.exports = __webpack_public_path__ + "static/media/soils_reports_4.ef85c034.png";


//////////////////
// WEBPACK FOOTER
// ./public/stem_soils_images/soils_reports_4.png
// module id = 1291
// module chunks = 0